import Vconsole from 'vconsole';

let vConsole = null;

console.log('当前环境====>', process.env.VUE_APP_ENV);
if (process.env.VUE_APP_ENV === 'dev') {
  vConsole = new Vconsole();
}

export default vConsole;
